<div class="form-group auto-group-selection">
  <ng-select #ngSelect class="form-control custom-select" required
              [ngClass]="{'has-selected': isSelectedItem() === true, 'error': hasError(), 'short-list': options.length < 4, 'long-list': options.length >= 4}"
              [name]="name"
              [items]="options"
              [disabled]="disabled"
              [multiple]="multiple"
              bindValue="id"
              bindLabel="name"
              [placeholder]="placeholder"
              [searchable]="searchable"
              [closeOnSelect]="!multiple && closeOptionAfterSelecting"
              [(ngModel)]="model"
              (open)="onOpenDopdown($event)"
              (close)="onCloseDopdown($event)"
              (blur)="onBlur($event)"
              (change)="onSelect($event)"
              (mouseover)="onMouseOver()">
    <ng-template ng-option-tmp let-item="item" let-index="index" let-search="searchTerm">
      <div (click)="onClickOption(item.id, $event)" class="option-inner" title="{{item.name}}">{{item.value}}</div>
    </ng-template>
    <ng-template *ngIf="multiple" ng-multi-label-tmp let-items="items" let-clear="clear">
      <div class="ng-value" *ngIf="numOfSelection() > 0">
        {{'new_group_settings.multi_select' | translate:{numOfSelected: numOfSelection()} }}
      </div>
      <div class="ng-value" *ngIf="numOfSelection() === 0">
        {{placeholder}}
      </div>
    </ng-template>
  </ng-select>
</div>



// WEBPACK FOOTER //
// ./src/app/main/group-details/new-group-settings/auto-group-filter-box/auto-group-filter-box.component.html